import { fromJS } from 'immutable';
import { LOAD_SERVICE_ANALYTICS_SUCCESS } from 'constants/ActionTypes';

const initialState = fromJS({
  serviceAnalytics: {
    dataset: null,
    pagination: null,
  },
});

const analyticsReducer = (state = initialState, action) => {
  if (action.type === LOAD_SERVICE_ANALYTICS_SUCCESS) {
    return state.set(
      'serviceAnalytics',
      fromJS({
        dataset: action.projectsServicesMap.items.map((service) => service.relationId),
        pagination: {
          totalCount: action.projectsServicesMap._meta.totalCount,
          pageCount: action.projectsServicesMap._meta.pageCount,
          currentPage: action.projectsServicesMap._meta.currentPage,
          perPage: action.projectsServicesMap._meta.perPage,
          totalCostAnalytics: action.projectsServicesMap._meta.totalCostAnalytics,
        },
      }),
    );
  }

  return state;
};

export default analyticsReducer;
